import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

/*
  Una red para que un fallo de pintado no deje el panel en blanco.

  Lo que pasó el 19-sep-2026: el backend mandaba el total del ticket como texto
  («1539.30») y la pantalla de Canjes QR hacía `.toFixed()` sobre él. Un texto no
  tiene ese método, así que la excepción tumbaba el árbol entero de React y la
  pestaña quedaba en blanco — sin mensaje, sin nada. Desde fuera parecía que el
  botón «no apuntaba a ningún lado», y llevaba así desde agosto.

  El arreglo de fondo ya está hecho; esto es para la próxima: si una sección
  revienta, se ve cuál y por qué, y el resto del panel sigue usable.
*/
export default class PantallaConFallo extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[Admin] La sección falló al pintarse:', error, info);
  }

  componentDidUpdate(prevProps) {
    // Al cambiar de sección se vuelve a intentar: el fallo era de la anterior.
    if (prevProps.seccion !== this.props.seccion && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="p-8">
        <div className="max-w-xl rounded-2xl border border-red-200 bg-red-50 p-6">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="font-semibold text-red-900">Esta sección no se pudo mostrar</h3>
              <p className="text-sm text-gray-700 mt-1 leading-relaxed">
                Algo falló al dibujarla. Las demás secciones siguen funcionando: puedes cambiar de pestaña.
                Si se repite, avísanos con lo que dice abajo.
              </p>
              <pre className="mt-3 text-xs text-gray-600 bg-white rounded-lg border border-red-100 p-3 overflow-x-auto">
                {String(this.state.error?.message || this.state.error)}
              </pre>
              <button
                onClick={() => window.location.reload()}
                className="mt-3 inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white border border-gray-300 text-sm text-gray-700 hover:bg-gray-100"
              >
                <RefreshCw className="w-4 h-4" /> Recargar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
